export default "__VITE_ASSET__CJA$vtFi__"